import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CheckItem } from '../CheckItem';
import { withoutSystem, withSystem } from '../../data/salesContent';
export function ComparisonSection() {
  return <section className="bg-zinc-950 px-5 py-20 md:py-28" data-id="element-81" data-mp="515usco5gf9i">
      <div className="mx-auto max-w-5xl" data-id="element-82" data-mp="52qo5yyq9s5s">
        <SectionHeading title="Preparar todo desde cero vs. trabajar con un sistema organizado." data-id="element-83" data-mp="9yefol0omxeg" />
        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-84" data-mp="3rewc603ywjb1">
          <div className="rounded-xl border border-zinc-800 bg-zinc-900/60 p-7 md:p-9" data-id="element-85" data-mp="19qsdfgcnty">
            <h3 className="font-display text-2xl font-extrabold uppercase tracking-wide text-zinc-400 md:text-3xl" data-id="element-86" data-mp="34e1ye74s17">Sin el Mega Pack</h3>
            <ul className="mt-6 space-y-4" data-id="element-87" data-mp="3ndu732nddd15">
              {withoutSystem.map(i => <CheckItem key={i} variant="cross" className="text-lg text-zinc-400" data-id="element-88" data-mp="3nbzqu1n1m93e">
                  {i}
                </CheckItem>)}
            </ul>
          </div>
          <div className="rounded-xl border-2 border-accent bg-zinc-900 p-7 md:p-9" data-id="element-89" data-mp="3dfobt3w2j559">
            <h3 className="font-display text-2xl font-extrabold uppercase tracking-wide text-accent md:text-3xl" data-id="element-90" data-mp="z6ftgw8lbc27">Con el Mega Pack</h3>
            <ul className="mt-6 space-y-4" data-id="element-91" data-mp="uaqtwswklv5w">
              {withSystem.map(i => <CheckItem key={i} className="text-lg font-medium text-zinc-50" data-id="element-92" data-mp="1874alzta5sjb">
                  {i}
                </CheckItem>)}
            </ul>
          </div>
        </div>
        <div className="mt-14 text-center" data-id="element-93" data-mp="ggg9gnrlwn5n">
          <p className="font-display mx-auto max-w-3xl text-3xl font-extrabold uppercase leading-tight text-zinc-50 md:text-5xl" data-id="element-94" data-mp="ghhkis8mh9nd">
            Tu próxima capacitación no tiene que empezar <span className="text-accent" data-id="element-95" data-mp="pacrprhnhffs">desde cero.</span>
          </p>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-zinc-400 md:text-xl" data-id="element-96" data-mp="kibbxvl9x6l0">
            Ahorrá tiempo de preparación y concentráte en lo que realmente importa:
          </p>
          <p className="font-display mx-auto mt-3 max-w-2xl text-2xl font-extrabold uppercase tracking-wide text-accent md:text-3xl" data-id="element-97" data-mp="3oxkvb6v17efx">
            Enseñar, demostrar y acompañar a tus alumnos.
          </p>
        </div>
      </div>
    </section>;
}